module.exports = __webpack_public_path__ + "static/img/gs_02.ee852dd6.png";